// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".value[data-v-65f65fa8]{font-size:2em!important}", "",{"version":3,"sources":["webpack://./chat/vue/widget/tabs/reviews/ReviewFormContent.vue"],"names":[],"mappings":"AACA,wBACI,uBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
